/**
 * Minimal client-side navigation helper.
 *
 * Replaced by TanStack Router when Phase 4 brings persistent editor state +
 * deep linking. Until then this thin shim lets us push history entries
 * without a full page reload.
 */
export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/** Match `/editor/<id>` and return the id, or null. */
export function matchEditor(pathname: string): string | null {
  const m = pathname.match(/^\/editor\/([^/]+)$/);
  return m ? decodeURIComponent(m[1] ?? '') : null;
}
